import { ReactNode } from 'react';
import styled from 'styled-components';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion, { AccordionProps } from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { FlexSpace } from '../Flex';
import WidgetButton from '../WidgetButton';

const AccordionStyled = styled(Accordion)`
  &.MuiAccordion-root {
    margin: 0;
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.palette.common.gray5};
  }
  & .MuiAccordionSummary-expandIconWrapper {
    color: ${({ theme }) => theme.palette.common.black};
  }
  & .MuiButtonBase-root {
    min-height: 0px;
  }
  & .MuiAccordionSummary-content.Mui-expanded {
    margin: 16px 0;
  }
  & .MuiAccordionDetails-root {
    padding: 0px 16px 16px;
  }
`;

type Props = {
  title: string | ReactNode;
  children: ReactNode;
  actionButtonTitle?: string;
  actionButtonIcon?: ReactNode;
  onActionButtonClick?: () => void;
} & Omit<AccordionProps, 'children' | 'title'>;

const Expandable = ({
  title,
  actionButtonTitle,
  actionButtonIcon,
  onActionButtonClick,
  children,
  ...props
}: Props) => (
  <AccordionStyled
    {...props}
    elevation={0}
    sx={{ '&:before': { height: '0px' } }}
  >
    <FlexSpace>
      <AccordionSummary
        sx={{ flexDirection: 'row-reverse', gap: 0.5, width: '100%' }}
        expandIcon={<ExpandMoreIcon />}
      >
        {title}
      </AccordionSummary>

      {actionButtonTitle !== undefined && (
        <WidgetButton
          sx={{ mr: '16px' }}
          onClick={onActionButtonClick}
          startIcon={actionButtonIcon}
        >
          {actionButtonTitle}
        </WidgetButton>
      )}
    </FlexSpace>

    <AccordionDetails>{children}</AccordionDetails>
  </AccordionStyled>
);

export default Expandable;
